<h1 mat-dialog-title>Cancel Reservation</h1>
<div mat-dialog-content class="pe-5">
    <p>Please confirm that you want to cancel this reservation.</p>
    <p class="mt-2">This cannot be undone.</p>
    <div class="d-flex flex-row justify-content-between mt-4 p-2">
        <div class="d-flex flex-column">
            <p class="text-decoration-underline">Created Date</p>
            <p>{{ data.createdDate | date }}</p>
        </div>
        <div class="d-flex flex-column">
            <p class="text-decoration-underline">Cancel Date</p>
            <p>{{ data.cancelDate | date }}</p>
        </div>
    </div>
</div>
<div mat-dialog-actions class="mt-3">
    <button mat-raised-button (click)="onActionClick(false)" class="cancel-finish-button">
        <mat-icon>cancel</mat-icon>
        Exit
    </button>
    <button mat-raised-button class="warn-button" (click)="onActionClick(true)">
        <mat-icon>delete</mat-icon>
        Confirm
    </button>
</div>